import { WIND_PAST_HOURS } from "@divespots/contracts";
import type { WindField } from "@divespots/contracts";
import { makeWindFieldFixture } from "@divespots/contracts/fixtures";

/**
 * The fixtures wind field like the live API's: it starts WIND_PAST_HOURS before the current hour
 * (the past hours repeat the first hour's values: invented data), so the e2e shows radar steps
 * with model wind.
 */
export function makeWindFieldWithPast(nowMs: number): WindField {
  const f = makeWindFieldFixture(nowMs);
  const first = Date.parse(f.times[0]!);
  const past = Array.from({ length: WIND_PAST_HOURS }, (_, k) =>
    new Date(first - (WIND_PAST_HOURS - k) * 3_600_000).toISOString(),
  );
  return {
    ...f,
    times: [...past, ...f.times],
    u: [...past.map(() => f.u[0]!), ...f.u],
    v: [...past.map(() => f.v[0]!), ...f.v],
  };
}
